<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { contentAttributes } = useMessageContext();

const items = computed(() => contentAttributes.value?.items || []);

// Discount cards are the imageless, button-free ones — product cards always
// carry a featured image (see ai-agent commands.py).
const isDiscount = item => !item.media_url;
</script>

<template>
  <BaseBubble class="p-3" data-bubble-name="cards">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="flex flex-col gap-2 w-64 max-w-full"
    >
      <template v-if="isDiscount(item)">
        <p v-if="item.description" class="mb-0 text-sm text-center">
          {{ item.description }}
        </p>
        <span
          class="px-3 py-2 font-mono text-base font-bold tracking-widest text-center border border-dashed rounded-lg border-n-slate-9 text-n-slate-12"
        >
          {{ item.title }}
        </span>
      </template>
      <template v-else>
        <img
          v-if="item.media_url"
          :src="item.media_url"
          class="object-cover w-full rounded-lg max-h-44"
        />
        <h6 class="mb-0 font-semibold text-n-slate-12">{{ item.title }}</h6>
        <p v-if="item.description" class="mb-0 text-sm">
          {{ item.description }}
        </p>
      </template>
      <a
        v-for="action in item.actions || []"
        :key="action.uri || action.payload"
        :href="action.uri"
        target="_blank"
        rel="noopener noreferrer nofollow"
        class="flex items-center justify-center w-full px-2 py-1.5 text-sm font-medium border rounded-lg border-n-weak text-n-brand hover:bg-n-alpha-1"
      >
        {{ action.text }}
      </a>
    </div>
  </BaseBubble>
</template>
